export default __webpack_public_path__ + "static/media/b5.fa41d3d1.svg";